// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import "../styles/navbar.css";
import logo from "../assets/logo.png";
import { FaInstagram, FaFacebookF } from "react-icons/fa";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(false);
  };

  return (
    <header className={`navbar ${isScrolled ? "navbar--scrolled" : ""}`}>
      <div className="container navbar-inner">
        <div className="navbar-left" onClick={() => handleNavClick("pocetna")}>
          <img
            src={logo}
            alt="KBIA poklon kutije logo"
            className="navbar-logo"
          />
          <div className="navbar-brand-text">
            <span className="navbar-brand-name">KBIA</span>
            <span className="navbar-brand-sub">poklon kutije</span>
          </div>
        </div>

        <nav className={`navbar-nav ${isOpen ? "navbar-nav--open" : ""}`}>
          <button
            className="navbar-link"
            onClick={() => handleNavClick("pocetna")}
          >
            Početna
          </button>
          <button
            className="navbar-link"
            onClick={() => handleNavClick("ponuda")}
          >
            Ponuda
          </button>
          <button
            className="navbar-link"
            onClick={() => handleNavClick("galerija")}
          >
            Galerija
          </button>
          <button
            className="navbar-link"
            onClick={() => handleNavClick("onama")}
          >
            O nama
          </button>
          <button
            className="navbar-link"
            onClick={() => handleNavClick("kontakt")}
          >
            Kontakt
          </button>
          <a
            href="https://shop.kbia.hr/wp/cjenik/"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-link"
            onClick={() => setIsOpen(false)}
          >
            Cjenik
          </a>
          <a
            href="https://shop.kbia.hr/wp/"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-link navbar-link--accent"
            onClick={() => setIsOpen(false)}
          >
            TRGOVINA
          </a>
          <div className="navbar-social">
            <a
              href="https://www.facebook.com/poklonkutijeKBIA"
              target="_blank"
              rel="noopener noreferrer"
              className="social fb"
              onClick={() => setIsOpen(false)}
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/poklonkutijedesignbykbia"
              target="_blank"
              rel="noopener noreferrer"
              className="social insta"
              onClick={() => setIsOpen(false)}
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </nav>

        <button
          className={`navbar-burger ${isOpen ? "navbar-burger--open" : ""}`}
          onClick={() => setIsOpen((o) => !o)}
          aria-label="Menu"
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
